define('models/modals/claim/index',['require','jquery','models/base/model','models/base/modal','models/base/sync-collection','models/base/sync-collection-model','lib/utils'],function(require) {
    'use strict';

    var $ = require('jquery'),
        Model = require('models/base/model'),
        ModalModel = require('models/base/modal'),
        SyncCollection = require('models/base/sync-collection'),
        SyncCollectionModel = require('models/base/sync-collection-model'),
        utils = require('lib/utils');

    var GoodsItem = Model.extend({
        defaults: {
            selected: false
        }
    });

    var GoodsItemCollection = SyncCollection.extend({
        model: GoodsItem
    });

    var FileItem = Model.extend({
        defaults: {
            selected: false,
            uploadUrl: '',
            progress: 0,
            showProgress: false,
            id: 1
        },
        initialize: function() {
            Model.prototype.initialize.apply(this, arguments);

            var file = this.get('file');

            if (file) {
                this.set({
                    name: file.name,
                    size: file.size,
                    url: '#',
                    canEdit: true
                });
                this.upload(file);
            }
        },
        destroy: function() {
            if (this.get('claimId')) {
                this.urlPath = '/files/claim/' + this.get('claimId') + '/' + this.get('name');
            } else {
                this.urlPath = '/files/claim-temp/' + this.get('fakeId') + '/' + this.get('name');
            }
            return Model.prototype.destroy.apply(this, arguments);
        },
        upload: function(file) {
            var _this = this;

            var formData = new FormData();

            formData.append('file', file);

            var onProgress = function (e) {
                var progress = (e.loaded / e.total) * 100;
                if (progress !== 100) {
                    _this.set('progress', progress);
                }
            };

            if (this.get('claimId')) {
                this.urlPath = '/files/claim/' + this.get('claimId');
            } else {
                this.set('fakeId', (new Date()).getTime());
                this.urlPath = '/files/claim-temp/' + this.get('fakeId');
            }

            return $.ajax({
                type: 'POST',
                url: this.url(),
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                xhr: function() {
                    var xhr = $.ajaxSettings.xhr();
                    if (xhr.upload) {
                        xhr.upload.addEventListener('progress', onProgress, false);
                    }
                    return xhr;
                },
                success: function(data) {
                    _this.set('progress', 100);
                    _this.trigger('uploadSuccess', data);
                },
                error: function(e) {
                    _this.set('progress', 100);
                    _this.trigger('uploadError', e);
                }
            });
        }
    });

    var FileItemCollection = SyncCollection.extend({
        model: FileItem
    });

    var DocItem = Model.extend({
        defaults: {
            selected: false
        }
    });

    var DocItemCollection = SyncCollection.extend({
        model: DocItem
    });

    var ClaimModalContent = SyncCollectionModel.extend({
        urlPath: '/pages/claim',
        collectionClass: {
            goods: GoodsItemCollection,
            files: FileItemCollection,
            docs: DocItemCollection
        },
        defaults: {
            cost: 0,
            currency: '',
            description: '',
            closed: -1,
            type: -1,
            status: -1,
            deleted: false,
            docs: [],
            goods: [],
            files: [],
            claimId: 0,
            loaded: false,
            canEdit: false
        },
        urlParams: function() {
            var params = SyncCollectionModel.prototype.urlParams.apply(this, arguments);
            params.claimId = this.get('claimId');
            return params;
        },
        parseSubCollection: function(coll, name, data) {
            var items = data[name];
            if (items) {
                for (var i=0, li=items.length; i<li; i++) {
                    items[i].canEdit = data.canEdit;
                }
            }
            return SyncCollectionModel.prototype.parseSubCollection.apply(this, arguments);
        },
        parse: function(data) {
            var isNewClaim = data.isNewClaim = (this.get('claimId') === 0 && this.get('tradeId'));

            if (isNewClaim) {
                data.canEdit = true;
            } else {
                data.canEdit = !data.deleted && !data.closed;
            }
            return SyncCollectionModel.prototype.parse.apply(this, arguments);
        }
    });

    var ClaimModalModel = ModalModel.extend({
        defaults: {
            'title': 'Претензия',
            'buttons': [
                { caption: 'Отмена', className: '', 'action': 'cancel' },
                { caption: 'Ок', className: 'btn-success', 'action': 'submit' }
            ],
            body: ''
        },
        constructor: function() {
            ModalModel.apply(this, arguments);
            this.content = new ClaimModalContent();
            var _this = this;
            this.content.on('afterLoad', function() {
                this.set('loaded', true);

                if (!this.get('isNewClaim')) {
                    _this.set('title', 'Претензия №' + this.get('claimNumber') + ' от ' + utils.date(this.get('claimDate')) + ' - ' + this.get('tradeCode'));
                }
                if (!this.get('canEdit')) {
                    _this.set('buttons', [
                        { caption: 'Закрыть', className: '', 'action': 'submit' }
                    ]);
                }
            });
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.content.dispose();
            ModalModel.prototype.dispose.apply(this, arguments);
        }
    });

    return ClaimModalModel;
});
